/**
 * Created by slava on 24.03.17.
 */

const RestartWindow = CleverappsWindow.extend({
    ctor: function (options) {
        this.messages = options.messages;
        this.retryDelay = options.retryDelay;
        this.onReload = options.onReload;
        this.onRetry = options.onRetry;

        this._super();

        this.setLocalZOrder(Transition.ZORDER + 1);
    },

    onWindowLoaded: function () {
        const messages = this.messages;

        this._super({
            name: "RestartWindow",
            title: Messages.has(messages.title) || messages.titleFallback,
            content: this.createContent(),
            closeButton: false
        });
    },

    createContent: function () {
        const styles = cleverapps.styles.RestartWindow;

        const text = cleverapps.UI.generateOnlyText(Messages.has(this.messages.description) || this.messages.descriptionFallback, cleverapps.styles.FONTS.WINDOW_TEXT);
        text.setDimensions(styles.text.width, styles.text.height);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_CENTER);

        return new cleverapps.Layout([text, this.retryDelay && this.createCountdown(), this.createButton()].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    createButton: function () {
        const styles = cleverapps.styles.RestartWindow.button;

        const text = this.onRetry ? Messages.has("RestartWindow.Retry") || "Try again" : Messages.has("RestartWindow.Reload") || "Reload";

        return new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            text,
            onClicked: () => this.onClick()
        });
    },

    createCountdown: function () {
        const countdown = cleverapps.UI.generateOnlyText("", cleverapps.styles.FONTS.WINDOW_TEXT);
        const deadline = Date.now() + this.retryDelay;

        const tick = () => {
            const seconds = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
            countdown.setString(Messages.replace(Messages.has("RestartWindow.Countdown") || "Retrying in %{seconds} s…", { seconds }));
        };
        tick();

        countdown.runAction(new cc.RepeatForever(new cc.Sequence(
            new cc.DelayTime(1),
            new cc.CallFunc(tick)
        )));

        return countdown;
    },

    onClick: function () {
        if (this.onRetry) {
            this.close();
            this.onRetry();
            return;
        }

        if (this.onReload) {
            this.onReload();
            return;
        }

        ErrorHandler.reload();
    },

    closeAnimation: function (callback) {
        callback();
    }
});

cleverapps.styles.RestartWindow = {
    margin: 30,

    text: {
        width: 590,
        height: 460
    },

    button: {
        width: 200,
        height: 90
    }
};

if (cleverapps.config.orientation === "horizontal") {
    cleverapps.increaseStylesByKoef(cleverapps.styles.RestartWindow, 1.4);
}
